module.exports = __webpack_public_path__ + "static/media/carno-logo-black.57d2ef65.png";